import cntl from "cntl";
import PropTypes from "prop-types";
import { IconChevronDown, IconChevronRight, IconRoute } from "@tabler/icons-react";
import TagCount from "./TagCount";

const propTypes = {
  label: PropTypes.string,
  isClicked: PropTypes.bool,
  onClick: PropTypes.func,
  alwaysOpen: PropTypes.bool,
};

function ListBlockHeader({ label, onClick, isClicked, counter, alwaysOpen }) {
  const navLinkCn = () => cntl`
    text-sm
    font-semibold
    py-2
    gap-x-3
    flex
    flex-row
    justify-center
    items-center
    cursor-pointer
    ${!alwaysOpen && isClicked ? "text-grey-700" : "text-grey-500"}
  `;

  return (
    <div onClick={() => onClick()} className={navLinkCn()}>
      {alwaysOpen ? (
        <IconRoute className="w-5 h-5 text-grey-500" />
      ) : isClicked ? (
        <IconChevronDown className="w-5 h-5 text-grey-500" />
      ) : (
        <IconChevronRight className="w-5 h-5 text-grey-500" />
      )}
      <div>{label}</div>
      {!alwaysOpen && <TagCount label={counter} />}
    </div>
  );
}

ListBlockHeader.propTypes = propTypes;
export default ListBlockHeader;
